<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '180px' : '120px'">
          <el-form-item label="推送时间" prop="pushDate">
          <el-input v-model="dataForm.pushDate" placeholder="推送时间"></el-input>
      </el-form-item>
          <el-form-item label="客户信息id" prop="customerId">
          <el-input v-model="dataForm.customerId" placeholder="客户信息id"></el-input>
      </el-form-item>
          <el-form-item label="公司信息id" prop="companyId">
          <el-input v-model="dataForm.companyId" placeholder="公司信息id"></el-input>
      </el-form-item>
          <el-form-item label="产品id" prop="productId">
          <el-input v-model="dataForm.productId" placeholder="产品id"></el-input>
      </el-form-item>
          <el-form-item label="门店id" prop="deptId">
          <el-input v-model="dataForm.deptId" placeholder="门店id"></el-input>
      </el-form-item>
          <el-form-item label="撞库推送消息" prop="repeatPushMsg">
          <el-input v-model="dataForm.repeatPushMsg" placeholder="撞库推送消息"></el-input>
      </el-form-item>
          <el-form-item label="撞库返回消息" prop="repeatRespMsg">
          <el-input v-model="dataForm.repeatRespMsg" placeholder="撞库返回消息"></el-input>
      </el-form-item>
          <el-form-item label="撞库状态:0,成功,1:失败" prop="repeatStatus">
          <el-select v-model="dataForm.repeatStatus"  clearable placeholder="撞库状态">
           <el-option 
                     v-for="item in pushList"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value"
           ></el-option>
         </el-select>
      </el-form-item>
          <el-form-item label="推送消息" prop="pushMsg">
          <el-input v-model="dataForm.pushMsg" placeholder="推送消息"></el-input>
      </el-form-item>
          <el-form-item label="推送返回消息" prop="respMsg">
          <el-input v-model="dataForm.respMsg" placeholder="推送返回消息"></el-input>
      </el-form-item>
      <el-form-item label="推送状态:0,成功,1:失败" prop="pushStatus">
          <el-select v-model="dataForm.pushStatus"  clearable placeholder="推送状态">
           <el-option 
                     v-for="item in pushList"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value"
           ></el-option>
         </el-select>
      </el-form-item>
      <el-form-item label="是否推送" prop="isPush">
          <el-select v-model="dataForm.isPush"  clearable placeholder="是否推送">
           <el-option 
                     v-for="item in isPushs"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value"
           ></el-option>
         </el-select>
      </el-form-item>
      <el-form-item label="计划推送时间" prop="scheduleTime">
        <el-date-picker
          v-model="dataForm.scheduleTime"
          type="datetime"
          placeholder="选择日期时间"
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </el-form-item>
       <!-- <el-form-item label-width="120px" label="是否计数" prop="deduct">
	      <el-select style="width: 200px;" v-model="dataForm.deduct" filterable clearable placeholder="请选择">
	          <el-option
	                  v-for="item in isPushs"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
	      </el-select>
      </el-form-item> -->
      <el-form-item label-width="120px" label="是否计数" prop="deductFlag">
	      <el-select style="width: 200px;" v-model="dataForm.deductFlag" filterable clearable placeholder="请选择">
	          <el-option
	                  v-for="item in isPushs"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
	      </el-select>
      </el-form-item>
          <!-- <el-form-item label="更新人" prop="updateBy">
          <el-input v-model="dataForm.updateBy" placeholder="更新人"></el-input>
      </el-form-item>
              <el-form-item label="更新日期" prop="updateTime">
          <el-input v-model="dataForm.updateTime" placeholder="更新日期"></el-input>
      </el-form-item>
          <el-form-item label="删除日期" prop="deleteTime">
          <el-input v-model="dataForm.deleteTime" placeholder="删除日期"></el-input>
      </el-form-item> -->
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        pushDate: '',
        customerId: '',
        companyId: '',
        productId: '',
        deptId: '',
        repeatPushMsg: '',
        repeatRespMsg: '',
        repeatStatus: '',
        pushMsg: '',
        respMsg: '',
        pushStatus: '',
        updateBy: '',
        creator: '',
        createDate: '',
        updateTime: '',
        deleteTime: '',
         deductFlag:'',
        deduct: '',
      },
      pushList:[
        {label:'成功',value:'0' },
        {label:'失败',value:'1' }
      ],
      isPushs:[
        {
            'label':'否',
            'value':0,
        },
        {
            'label':'是',
            'value':1,
        }
      ],
    }
  },
  computed: {
    dataRule () {
      return {
        pushDate: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        customerId: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        companyId: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productId: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deptId: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        repeatPushMsg: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        repeatRespMsg: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        repeatStatus: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pushMsg: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        respMsg: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pushStatus: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateBy: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/customerpushlog/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/customerpushlog/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
